import { InputColumnItem } from "./InputColumn";

interface ColumnMap {
  [key: string]: number;
}

import {
  // COLUMN_DATE,
  // COLUMN_TEAMS,
  // COLUMN_CURRENT,
  // COLUMN_OPEN,
  // COLUMN_LINE_MOVE,
  COLUMN_VALUE_RATING,
  COLUMN_PUBLIC_TICKET_PCT,
  COLUMN_PUBLIC_MONEY,
  COLUMN_LINE_MOVE_SPREAD,
  COLUMN_INJURIES,
  COLUMN_PRO_MONEY_EDGE,
  COLUMN_TOTAL_GAMES,
  COLUMN_LINE_MOVE_ML,
  COLUMN_LINE_MOVE_OU,
  COLUMN_UNDER_RECORD,
  COLUMN_SEASON_WIN_PCT,
  COLUMN_ATS_RECORD,
  COLUMN_ATS_WIN_PCT,
  COLUMN_OVER_RECORD,
  COLUMN_OVER_PCT,
  COLUMN_UNDER_PCT,
  COLUMN_ROT_NUMBER,
  COLUMN_CURRENT_SPREAD,
  COLUMN_OPEN_SPREAD,
  COLUMN_CURRENT_ML,
  COLUMN_OPEN_ML,
  COLUMN_CURRENT_OU,
  COLUMN_OPEN_OU,
  COLUMN_PUBLIC_TICKET_TOT_SPREAD,
  COLUMN_PUBLIC_TICKET_TOT_ML,
  COLUMN_PUBLIC_TICKET_TOT_OVER,
  COLUMN_PUBLIC_TICKET_TOT_UNDER,
  COLUMN_NET_UNITS,
  COLUMN_ATS_UNITS,
  COLUMN_PITCHERS,
  COLUMN_PTS_FOR,
  COLUMN_PTS_AGAINST,
  COLUMN_HOME_RECORD,
  COLUMN_ROAD_RECORD,
  COLUMN_HOME_ATS_RECORD,
  COLUMN_ROAD_ATS_RECORD,
  COLUMN_HOME_OU_RECORD,
  COLUMN_ROAD_OU_RECORD,
} from "../../../constants";

// If you add a new column, please put it in the Google Sheet located at:
// https://docs.google.com/spreadsheets/d/1BcVXkt7_Y_8MUDy6rI7TXfrr47KVQt5_zyk50xqF9GM/edit#gid=1176283405

export const COMMON_EVENT_SETTINGS: InputColumnItem[] = [
  {
    name: "Best Bet Rating",
    key: "rating",
    column: COLUMN_VALUE_RATING,
    isSharp: false,
  },
  {
    name: "Public Betting %",
    key: "publicTicket",
    column: COLUMN_PUBLIC_TICKET_PCT,
    isSharp: false,
  },
  {
    name: "Public Money %",
    key: "publicMoney",
    column: COLUMN_PUBLIC_MONEY,
    isSharp: false,
  },
  // {
  //   name: "Total # of Public Tickets - Spread",
  //   key: "publicTicketSpread",
  //   column: COLUMN_PUBLIC_TICKET_TOT_SPREAD,
  //   isSharp: true,
  // },
  // {
  //   name: "Total # of Public Tickets - Moneyline",
  //   key: "pulicTicketML",
  //   column: COLUMN_PUBLIC_TICKET_TOT_ML,
  //   isSharp: true,
  // },
  // {
  //   name: "Total # of Public Tickets - Over",
  //   key: "publicTicketOver",
  //   column: COLUMN_PUBLIC_TICKET_TOT_OVER,
  //   isSharp: true,
  // },
  // {
  //   name: "Total # of Public Tickets - Under",
  //   key: "publicTicketUnder",
  //   column: COLUMN_PUBLIC_TICKET_TOT_UNDER,
  //   isSharp: true,
  // },
  {
    name: "Pro Betting %",
    key: "proMoneyEdge",
    column: COLUMN_PRO_MONEY_EDGE,
    isSharp: false,
  }, //money % minus ticket %
  {
    name: "News & Injuries",
    key: "injury",
    column: COLUMN_INJURIES,
    isSharp: false,
  },
];

export const SPREAD_EVENT_SETTINGS: InputColumnItem[] = [
  {
    name: "ATS Record",
    key: "atsRecord",
    column: COLUMN_ATS_RECORD,
    isSharp: false,
  },
  {
    name: "ATS Win %",
    key: "atsWinPct",
    column: COLUMN_ATS_WIN_PCT,
    isSharp: false,
  },
  {
    name: "Home ATS Record",
    key: "homeATSRecord",
    column: COLUMN_HOME_ATS_RECORD,
    isSharp: false,
  },
  {
    name: "Road ATS Record",
    key: "roadATSRecord",
    column: COLUMN_ROAD_ATS_RECORD,
    isSharp: false,
  },
  {
    name: "ATS Units",
    key: "atsUnits",
    column: COLUMN_ATS_UNITS,
    isSharp: false,
  }, // from Statfox
];

export const TOTALS_EVENT_SETTINGS: InputColumnItem[] = [
  {
    name: "Over Record (O - U - P)",
    key: "overRecord",
    column: COLUMN_OVER_RECORD,
    isSharp: false,
  },
  {
    name: "Under Record (U - O - P)",
    key: "underRecord",
    column: COLUMN_UNDER_RECORD,
    isSharp: false,
  },
  { name: "Over %", key: "overPct", column: COLUMN_OVER_PCT, isSharp: false },
  {
    name: "Under %",
    key: "underPct",
    column: COLUMN_UNDER_PCT,
    isSharp: false,
  },
  {
    name: "Home O/U Record",
    key: "homeOURecord",
    column: COLUMN_HOME_OU_RECORD,
    isSharp: false,
  },
  {
    name: "Road O/U Record",
    key: "roadOURecord",
    column: COLUMN_ROAD_OU_RECORD,
    isSharp: false,
  },
];

export const LINE_TYPE_SETTINGS: InputColumnItem[] = [
  {
    name: "Rotation Number",
    key: "rotNumber",
    column: COLUMN_ROT_NUMBER,
    isSharp: false,
  },
  {
    name: "Live - Spread",
    key: "currentSpread",
    column: COLUMN_CURRENT_SPREAD,
    isSharp: false,
  },
  {
    name: "Open - Spread",
    key: "openSpread",
    column: COLUMN_OPEN_SPREAD,
    isSharp: false,
  },
  {
    name: "Live - ML",
    key: "currentML",
    column: COLUMN_CURRENT_ML,
    isSharp: false,
  },
  { name: "Open - ML", key: "openML", column: COLUMN_OPEN_ML, isSharp: false },
  {
    name: "Live - O/U",
    key: "currentOU",
    column: COLUMN_CURRENT_OU,
    isSharp: false,
  },
  { name: "Open - O/U", key: "openOU", column: COLUMN_OPEN_OU, isSharp: false },
  {
    name: "Line Move - Spread",
    key: "lineMoveSpread",
    column: COLUMN_LINE_MOVE_SPREAD,
    isSharp: false,
  },
  {
    name: "Line Move - ML",
    key: "lineMoveMoneyline",
    column: COLUMN_LINE_MOVE_ML,
    isSharp: false,
  },
  {
    name: "Line Move - O/U",
    key: "lineMoveOverUnder",
    column: COLUMN_LINE_MOVE_OU,
    isSharp: false,
  },
];

export const TEAM_BETTING_SETTINGS: InputColumnItem[] = [
  {
    name: "Total Games",
    key: "totalGames",
    column: COLUMN_TOTAL_GAMES,
    isSharp: false,
  },
  {
    name: "Season Win %",
    key: "seasonWinPct",
    column: COLUMN_SEASON_WIN_PCT,
    isSharp: false,
  },
  {
    name: "Home Record",
    key: "homeRecord",
    column: COLUMN_HOME_RECORD,
    isSharp: false,
  },
  {
    name: "Road Record",
    key: "roadRecord",
    column: COLUMN_ROAD_RECORD,
    isSharp: false,
  },
  {
    name: "Current Year Net Units",
    key: "netUnits",
    column: COLUMN_NET_UNITS,
    isSharp: false,
  },
];

export const NBA_TEAM_STATS: InputColumnItem[] = [
  {
    name: "Points For",
    key: "pointsFor",
    column: COLUMN_PTS_FOR,
    isSharp: false,
  },
  {
    name: "Points Against",
    key: "pointsAgainst",
    column: COLUMN_PTS_AGAINST,
    isSharp: false,
  },
];

export const columnLookupTable: ColumnMap = {
  atsRecord: COLUMN_ATS_RECORD,
  atsUnits: COLUMN_ATS_UNITS,
  atsWinPct: COLUMN_ATS_WIN_PCT,
  currentML: COLUMN_CURRENT_ML,
  currentOU: COLUMN_CURRENT_OU,
  currentSpread: COLUMN_CURRENT_SPREAD,
  injury: COLUMN_INJURIES,
  lineMoveMoneyline: COLUMN_LINE_MOVE_ML,
  lineMoveOverUnder: COLUMN_LINE_MOVE_OU,
  lineMoveSpread: COLUMN_LINE_MOVE_SPREAD,
  netUnits: COLUMN_NET_UNITS,
  openML: COLUMN_OPEN_ML,
  openOU: COLUMN_OPEN_OU,
  openSpread: COLUMN_OPEN_SPREAD,
  overPct: COLUMN_OVER_PCT,
  overRecord: COLUMN_OVER_RECORD,
  publicMoney: COLUMN_PUBLIC_MONEY,
  publicTicket: COLUMN_PUBLIC_TICKET_PCT,
  pulicTicketML: COLUMN_PUBLIC_TICKET_TOT_ML,
  publicTicketOver: COLUMN_PUBLIC_TICKET_TOT_OVER,
  publicTicketUnder: COLUMN_PUBLIC_TICKET_TOT_UNDER,
  publicTicketSpread: COLUMN_PUBLIC_TICKET_TOT_SPREAD,
  proMoneyEdge: COLUMN_PRO_MONEY_EDGE,
  rotNumber: COLUMN_ROT_NUMBER,
  seasonWinPct: COLUMN_SEASON_WIN_PCT,
  totalGames: COLUMN_TOTAL_GAMES,
  underPct: COLUMN_UNDER_PCT,
  underRecord: COLUMN_UNDER_RECORD,
  rating: COLUMN_VALUE_RATING,
  pitchers: COLUMN_PITCHERS,
  pointsFor: COLUMN_PTS_FOR,
  pointsAgainst: COLUMN_PTS_AGAINST,
};
